<template>
  <div id="app">
    <TopNav />
    <router-view />
  </div>
</template>

<script>
  import TopNav from "./components/TopNav.vue";

  export default {
    name: "App",
    components: {
      TopNav
    }
  };
</script>

<style>
  body {
    margin: 0 0 0 0;
    background-color: rgb(246, 246, 246);
  }
  #app {
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: rgb(52, 52, 52);
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue